import IApplicationForm from "./IApplicationForm";
import Culture from "../../page/CultureEnum";
import ICurrency from "../../dto/ICurrency";
import Currency from "../../dto/Currency";
import Customer from "./Customer";
import ICustomer from "./ICustomer";
import IEnvSettings from "@/module/main/model/applicationForm/IEnvSettings";
import EnvSettings from "@/module/main/model/applicationForm/EnvSettings";
import ILoan from "@/module/main/model/applicationForm/ILoan";
import Loan from "@/module/main/model/applicationForm/Loan";
import IEndpoints from "@/module/main/model/applicationForm/IEndpoints";
import Endpoints from "@/module/main/model/applicationForm/Endpoints";

export default class ApplicationForm implements IApplicationForm
{
    constructor(
        public currency: ICurrency = new Currency(),
        public culture: Culture = Culture.CZ,
        public envSettings: IEnvSettings = new EnvSettings(),
        public customer: ICustomer = new Customer(),
        public loan: ILoan = new Loan(),
        public endpoints: IEndpoints = new Endpoints()
    )
    {
    }
}
